import ActionTypes from "../../../constants/ActionTypes";
import { IFetchSSOTestData, IGetSSORedirect, IFetchSSOTestToken, ILogoutFromTnAccount, ISetProfileFromTnAccount, ISetSSOTestData, IGetSSORedirectTest, ISetSSOTestToken } from "./types";

export const setProfileFromTnAccount = (accessToken: any, from: string): ISetProfileFromTnAccount => ({
  type: ActionTypes.AUTH.SET_USER_PROFILE_FROM_TN_ACCOUNT,
  payload: {
    accessToken: accessToken,
    from: from
  }
});

export const logoutFromTnAccount = (): ILogoutFromTnAccount => ({
  type: ActionTypes.AUTH.LOGOUT_FROM_TN_ACCOUNT,
});

// SSO

export const getSSORedirect = (data: any): IGetSSORedirect => ({
  type: ActionTypes.SSO.GET_SSO_REDIRECT,
  payload: data
});

// SSO TEST
export const fetchSSOTestData = (): IFetchSSOTestData => ({
  type: ActionTypes.SSO.FETCH_SSO_TEST_DATA,
});

export const setSSOTestData = (data: any): ISetSSOTestData => ({
  type: ActionTypes.SSO.SET_SSO_TEST_DATA,
  payload: data
});

export const fetchSSOTestToken = (data: any): IFetchSSOTestToken => ({
  type: ActionTypes.SSO.FETCH_SSO_TEST_TOKEN,
  payload: {
    data
  }
});

export const setSSOTestToken = (token: string): ISetSSOTestToken => ({
  type: ActionTypes.SSO.SET_SSO_TEST_TOKEN,
  payload: {
    token
  }
});

export const getSSOTestRedirect = (): IGetSSORedirectTest => ({
  type: ActionTypes.SSO.GET_SSO_TEST_REDIRECT
});
